/**
 * Hero Animations using GSAP ScrollTrigger & GSAP SplitText
 */

import { decodeChars } from "../helpers/decodeChars";

export class HeroAnimations {
  constructor() {
    this.init();
  }

  /**
   * Initialize animations
   */
  init() {
    if (
      typeof gsap === "undefined" ||
      typeof ScrollTrigger === "undefined" ||
      typeof SplitText === "undefined"
    ) {
      console.warn("GSAP, ScrollTrigger, or SplitText not loaded");
      return;
    }

    gsap.registerPlugin(ScrollTrigger, SplitText);
    this.mm = gsap.matchMedia();

    this.homeHeroAnimations();
  }

  /**
   * Home Hero Animations on load
   */
  homeHeroAnimations() {
    const section = document.querySelector(".wps-header-hero__wrapper");
    if (!section) return;

    const originalChars = "HERITAGE AMUSEMENTS".split("");
    const chars = [...section.querySelectorAll(".text-chars")];

    const tl = gsap.timeline({
      defaults: { ease: "power2.out" },
    });

    chars.forEach((char, index) => {
      const original = originalChars[index];

      if (char.textContent !== original) {
        tl.call(
          () => {
            decodeChars(char, original, index, 1);
          },
          null,
          0,
        );
      }
    });
  }
}
